mutation DeleteTextAutomation($textAutomation: TextAutomationDeleteInput!) {
    textAutomationDelete(input: $textAutomation) {
        textAutomation {
            id
        }
    }
}
